import { SvgIcon, SvgIconProps } from '@mui/material';

export default function StarOutlinedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.6807 1.59328L9.2807 4.75028H12.0267C12.3299 4.75061 12.6029 4.93392 12.7179 5.21443C12.833 5.49494 12.7673 5.81715 12.5517 6.03028L10.0467 8.50028L11.4367 11.6913C11.5656 11.9878 11.4909 12.3335 11.251 12.5503C11.0112 12.7671 10.6597 12.8065 10.3777 12.6483L6.9997 10.7483L3.6217 12.6483C3.33973 12.8065 2.98824 12.7671 2.74835 12.5503C2.50847 12.3335 2.43375 11.9878 2.5627 11.6913L3.9527 8.50028L1.4527 6.04128C1.23465 5.82694 1.16785 5.50202 1.28368 5.21904C1.3995 4.93607 1.67494 4.75123 1.9807 4.75128H4.7147L6.3147 1.59428C6.44353 1.33509 6.70794 1.17111 6.99739 1.1709C7.28684 1.17069 7.55148 1.33428 7.6807 1.59328V1.59328Z"
          stroke="#67707e"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
